import React from 'react';
import {Header, Breadcrumb, Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import FormMaker from "../common/FormMaker"





const Cuestionario=({ id, color, form, onSave,onChange, ajaxCallInProgress, errors={}, strings, permisos, formulario,  datosGenerales, onAgregarImagenServicio, onBorrarArchivo})=>{

	return (
        <Container>
        <Dimmer.Dimmable   dimmed={ajaxCallInProgress>0?true:false}>
        
        
            <FormMaker
                    formulario={formulario}
                    onChange={onChange} 
                    datosGenerales={datosGenerales}
                    onSave={onSave}                    
                    errors={errors}
                    onAgregarImagenServicio={onAgregarImagenServicio}
                    onBorrarArchivo={onBorrarArchivo}
                />
        
                 <Button onClick={onSave} >Guardar</Button>
    
        </Dimmer.Dimmable>
        </Container>
	);
};



export default Cuestionario;